module.exports = __webpack_public_path__ + "static/media/woman_front_outline.24e05b60.png";